export const EmailIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <defs />
      <path d="M23.3.62,9.23,17.6l-.91,5.9a.8.8,0,0,1-.76-.53l-2.61-7.2Z" fill="#c4f0eb" />
      <path
        d="M23.3.62,4.95,15.77l-3.8-1.63A1.087,1.087,0,0,1,.5,13.2a1.064,1.064,0,0,1,.56-.99L22.71.56A.532.532,0,0,1,23.3.62Z"
        fill="#f8fafc"
      />
      <path
        d="M23.48,1.18,18.17,20.11a1.049,1.049,0,0,1-.57.68,1.079,1.079,0,0,1-.88.02l-4.84-2.08L8.99,23.14a.816.816,0,0,1-.67.36l.91-5.9L23.3.62A.519.519,0,0,1,23.48,1.18Z"
        fill="#f8fafc"
      />
      <line
        x1={4.953}
        y1={15.765}
        x2={23.299}
        y2={0.617}
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.231,17.6l7.489,3.209a1.069,1.069,0,0,0,1.452-.7L23.48,1.18a.535.535,0,0,0-.769-.616L1.063,12.208a1.071,1.071,0,0,0,.086,1.927l3.8,1.63"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.953,15.765l2.6,7.2a.805.805,0,0,0,1.431.168l2.889-4.4"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <polyline
        points="23.299 0.617 9.231 17.599 8.315 23.5"
        fill="none"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
